/**
 * @generated SignedSource<<daf63fd2b0ace8a4acae033f236bb3e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type PolicyRestrictionName = "SPOT_MARGIN_ALREADY_PROVISIONED" | "SPOT_MARGIN_APPLICATION" | "SPOT_MARGIN_BORROW" | "SPOT_MARGIN_REPAY" | "SPOT_MARGIN_VIEW" | "account_restricted" | "agreement_global_derivative_trading" | "alias_name" | "already_provisioned" | "appropriateness_assessment_questionnaire" | "attestations" | "basic_kyc_required" | "birthplace" | "ca_appropriateness_assessment" | "cbel_derivative_cdd" | "crossriver_blocked" | "customer_categorization_questionnaire" | "customer_due_diligence" | "deposit_required" | "derivative_cdd" | "derivative_knowledge_check" | "derivative_onboarding_tmd" | "derivative_risk_ack" | "disable_crypto_sends_for_account_recoveries" | "disable_crypto_sends_for_password_reset_high_account_balance" | "disable_crypto_sends_for_password_reset_medium_account_balance" | "disable_crypto_sends_for_risky_phone_numbers_account_recovery" | "document_verification" | "document_verification_with_facematch" | "edpc" | "email" | "extended_customer_due_diligence" | "finprom_continue_service" | "finprom_trading_risk_agreement" | "futures_birthplace" | "futures_cbfse_birthplace" | "futures_cbfse_due_diligence" | "futures_cbfse_id_verification" | "futures_cbfse_knowledge_check" | "futures_cbfse_risk_acknowledgement" | "futures_cbfse_tax_identity" | "futures_customer_due_diligence" | "futures_high_risk_blocked" | "futures_high_risk_rejected" | "futures_high_risk_review_pending" | "futures_high_risk_undetermined" | "futures_identity_document_verification" | "futures_identity_document_verification_with_facematch" | "futures_knowledge_check" | "futures_risk_acknowledgement" | "futures_trading_blocked" | "futures_trading_due_diligence" | "futures_trading_employment" | "futures_trading_id_selection" | "futures_trading_id_verification" | "futures_trading_sweep_selection" | "futures_trading_terms" | "high_risk_cancel" | "id_verification_attempt" | "id_verification_required" | "identity_document_verification_attempt" | "identity_document_verification_with_facematch_attempt" | "identity_verification" | "identity_verification_attempt" | "idv_required" | "idv_with_face_match_required" | "idv_with_id_card" | "incomplete_progressive_onboarding" | "intx_trading_due_diligence" | "jumio" | "jumio_face_match" | "jumio_textmatch" | "kyc_only" | "linked_indian_bank_account_restriction" | "marqeta_idv" | "milestone_idology" | "milestone_jumio" | "milestone_jumio_face_match" | "name" | "nationality" | "payment_method_required" | "payment_pending" | "payment_required" | "pending_screening" | "personal_details" | "phone" | "poa" | "proof_of_address" | "proof_of_address_required" | "proof_of_professional_trader" | "recalculating_volumes" | "region_unsupported" | "registration_cool_off" | "self_certification_tax_identity" | "send_disabled" | "send_only" | "sg_risk_assessment" | "social_engineering_questionnaire" | "state_unsupported" | "suitability" | "tax_id_required" | "terms_of_service" | "unban_self_serve" | "unsuitable_user_blocker" | "user_details_confirmation" | "user_id_collection" | "vendor_verification" | "virtual_account_agreement" | "w9_verification" | "zero_limit" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PolicyRestrictionsGuardFragment$data = {
  readonly buyRestrictions?: ReadonlyArray<{
    readonly description: string;
    readonly link: {
      readonly text: string;
      readonly url: string;
    };
    readonly message: string;
    readonly restrictionName: PolicyRestrictionName;
  } | null> | null;
  readonly isWebview2faEligible?: boolean | null;
  readonly sendRestrictions?: ReadonlyArray<{
    readonly description: string;
    readonly link: {
      readonly text: string;
      readonly url: string;
    };
    readonly message: string;
    readonly restrictionName: PolicyRestrictionName;
  } | null> | null;
  readonly userProperties: {
    readonly country: {
      readonly code: string;
      readonly name: string;
    } | null;
    readonly uuid: string;
  };
  readonly " $fragmentType": "PolicyRestrictionsGuardFragment";
};
export type PolicyRestrictionsGuardFragment$key = {
  readonly " $data"?: PolicyRestrictionsGuardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PolicyRestrictionsGuardFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "restrictionName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Link",
    "kind": "LinkedField",
    "name": "link",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "buys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "inWebView"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sends"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./PolicyRestrictionsGuardRefetchableFragment.graphql')
    }
  },
  "name": "PolicyRestrictionsGuardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProperties",
      "kind": "LinkedField",
      "name": "userProperties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Country",
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "inWebView",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isWebview2faEligible",
          "storageKey": null
        }
      ]
    },
    {
      "condition": "sends",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "sendRestrictions",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "sends"
            }
          ],
          "concreteType": "PolicyRestriction",
          "kind": "LinkedField",
          "name": "policyRestrictions",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": "policyRestrictions(action:\"sends\")"
        }
      ]
    },
    {
      "condition": "buys",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "buyRestrictions",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "buys"
            }
          ],
          "concreteType": "PolicyRestriction",
          "kind": "LinkedField",
          "name": "policyRestrictions",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": "policyRestrictions(action:\"buys\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "1ce67022e15e22e6e3c216e7fc3b8f3c";

export default node;
